export default __webpack_public_path__ + "static/media/DENTISTCERTIFICATE.df1f55ce.png";